import { combineReducers } from "redux";
import timezoneReducer from "./timezone/timezoneReducer";
import userReducer from "./user/userReducer";

const rootReducer = combineReducers({
  timezoneReducer,
  userReducer,
});
export default rootReducer;
